import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';
declare function setProgress(percentual, masc): any;

@Component({
  selector: 'app-me-avaliacao',
  templateUrl: './me-avaliacao.component.html',
  styleUrls: ['./me-avaliacao.component.css']
})
export class MeAvaliacaoComponent implements OnInit, OnDestroy {
  existeAv: boolean = false;
  hideCL: boolean = false;
  arrAvaliacoes: any[] = [];
  idAvaliacao: any;
  masculino: boolean = true;

  dadosCirc: any = '';
  dadosDobra: any = '';
  dadosComp: any = '';
  dadosCooper: any = '';
  dadosRM: any = '';
  dadosAV: any = '';
  dadosGET: any = '';
  //graph things
  public single = [];
  public multi = [];
  view: any[] = [600, 400];

  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Composição Corporal';
  showYAxisLabel = true;
  yAxisLabel = 'Peso';
  timeline = true;
  colorScheme = {
    domain: ['#58DC65', '#EEE244', '#DE5353', '#2ade89',]
  };
  mRotaAtual: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    //this.hideCL = true;
    //this.existeTreino = true;
    this.tmaService.eventoFS(true);
    this.idAvaliacao = this.route.snapshot.paramMap.get('idavaliacao');
    setTimeout(() => {
      this.loadScript('../../assets/js/fillbody.js');
    }, 0);

    this.mRotaAtual = 'me/avaliacao/' + this.route.snapshot.paramMap.get('idavaliacao');
    //this.mRotaAtual = (<any>this._location)._platformLocation.location.href;

    this.carregarAvaliacao();
    //this.tmaService.hcPremium = true;
    // var numeroPerc = this.dadosComp.MassaGorduraPercentual / 100;
    // setProgress(numeroPerc, this.masculino);

    //setProgress(0.25, this.masculino);
  }

  ngOnDestroy() {
    this.tmaService.eventoFS(false);
  }
  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  goFichaTreino(idTreino: any): void {
    this.router.navigate(['me/fichatreino/' + idTreino]);
  }


  carregarAvaliacao(): void {
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idavaliacao=' + this.idAvaliacao;
    this.tmaService.infoAvaliacao(gDados)
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideCL = true;
        if (qRes['res'] == 'ok') {
          this.dadosDobra = qRes['infoDobras'];
          this.dadosCirc = qRes['infoCirc'];
          this.dadosComp = qRes['infoComp'];
          this.dadosCooper = qRes['infoCooper'];
          this.dadosRM = qRes['infoRM'];
          this.dadosAV = qRes['infoAv'];
          this.dadosGET = qRes['infoGET'];

          if (qRes['sexo'] == 'Masculino') {
            this.masculino = true;
          }
          else {
            this.masculino = false;
          }
          if(qRes['infoComp'] != null){
            console.log("MG%" + qRes['infoComp'].MassaGorduraPercentual);
            var numeroPerc = qRes['infoComp'].MassaGorduraPercentual / 100;
            setProgress(numeroPerc, this.masculino);
            this.renderizarGrafico();
          }

          
        }
      })
  }

  showUA() :void{
    alert(window.navigator.userAgent);
  }
  renderizarGrafico(): void {

    this.single = [{
      "name": "Peso Total ",
      "value": this.dadosComp.MassaCorporal
    },
    {
      "name": "Massa de Gordura",
      "value": this.dadosComp.MassaGorduraKg
    },
    {
      "name": "Massa Magra",
      "value": this.dadosComp.MassaLivreGorduraKg
    },
    ];

  }

  changeCk(idAval: any, qDone: any) {
    this.arrAvaliacoes.find(x => x.Id == idAval).ck = qDone;
    console.log(this.arrAvaliacoes);
  }


  goComparar(): void {
    //verificar qty check
    if (this.tmaService.hcPremium) {
      //premium pode comparar
      var qtyC = 0;
      var armazenaIds = '';
      this.arrAvaliacoes.forEach(element => {
        if (element.ck) {
          qtyC++;
          armazenaIds += element.Id + '-';
        }
      });
      if (qtyC > 1) {
        if (qtyC <= 6) {
          //liberado
          armazenaIds = armazenaIds.slice(0, -1);
          this.router.navigate(['/me/evolucao/' + armazenaIds]);
        }
        else {
          //aviso maximo
          const erroQty = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Limite Atingido", textoAlerta: "É permitido comparar até 6 (seis) avaliações ao mesmo tempo. Desmarque algumas e tente novamente", iconAlerta: 'warning' }
          })
        }
      }
      else {
        //aviso minimo
        const erroQty = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Comparar Avaliações", textoAlerta: "Você deve selecionar pelo menos 2 (duas) avaliações para realizar uma comparação!", iconAlerta: 'warning' }
        })
      }
    }
    else {
      if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios'){
        //deixamos apenas 2 avaliações
        if (qtyC > 1) {
          if (qtyC <= 2) {
            //liberado
            armazenaIds = armazenaIds.slice(0, -1);
            this.router.navigate(['/me/evolucao/' + armazenaIds]);
          }
          else {
            //aviso maximo
            const erroQty = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { tituloAlerta: "Limite Atingido", textoAlerta: "É permitido comparar até 2 (duas) avaliações ao mesmo tempo. Desmarque algumas e tente novamente", iconAlerta: 'warning' }
            })
          }
        }
        else {
          //aviso minimo
          const erroQty = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Comparar Avaliações", textoAlerta: "Você deve selecionar pelo menos 2 (duas) avaliações para realizar uma comparação!", iconAlerta: 'warning' }
          })
        }
      }
      else{
        const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
          width: '300px',
          data: { tituloAlerta: "Premium", textoAlerta: "Esta é uma funcionalidade exclusiva para usuários premium. Deseja saber mais sobre os benefícios?", textoCancel: "Não", textoConfirm: "SIM" }
        });
        dialogRefConf.afterClosed().subscribe(result => {
          if (result == true) {
            this.router.navigate(['/premium']);
          }
        });
      }
      
    }

  }
  goDetail(idAvaliacao: any): void {
    this.router.navigate(['/me/avaliacao/' + idAvaliacao]);
  }

  voltar(): void {
    this.router.navigate(['/me/avaliacoes']);
    //this._location.back();
  }
}
